var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4 L44,24 L24,44 L4,24 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28 V21 H28 V17 L37,24 L28,31 V27 H20 V28 Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11 A5,5 0,1 0,11,21 A5,5 0,1 0,11,11",
    fill: "#00D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11,14 A2,2 0,1 0,11,18 A2,2 0,1 0,11,14",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessDirections);
export default __webpack_public_path__ + "static/media/p4r_business_directions.5fc282dd7382058ed36d9b1250eafacd.svg";
export { ForwardRef as ReactComponent };